import { motion, AnimatePresence } from 'framer-motion';
import { useAuth } from '@/context/AuthContext';
import Layout from '@/components/layout/Layout';
import SEO from '@/components/SEO';
import Hero from '@/components/landing/sections/Hero';
import HowItWorks from '@/components/landing/sections/HowItWorks';
import AIFeatures from '@/components/landing/sections/AIFeatures';
import PrivacyProtection from '@/components/landing/sections/PrivacyProtection';
import EmergingContent from '@/components/landing/sections/EmergingContent';
import LaunchSection from '@/components/landing/sections/LaunchSection';
import TopSnaps from '@/components/landing/sections/TopSnaps';
import CashSnaps from '@/components/landing/sections/CashSnaps';
import Footer from '@/components/layout/Footer';
import useScrollToTop from '@/hooks/useScrollToTop';

export default function Landing() {
  const { user } = useAuth();
  useScrollToTop();

  // If user is authenticated, wrap content in Layout component
  if (user) {
    return (
      <Layout>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <SEO 
            title="SnapVote - Make Better Decisions Together"
            description="Create engaging polls, gather meaningful insights, and make better decisions together. Join the community of curious minds and decision makers."
          />
          <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white -mt-16">
            <Hero />
            <TopSnaps />
            <CashSnaps />
            <HowItWorks />
            <AIFeatures />
            <PrivacyProtection />
            <EmergingContent />
            <LaunchSection />
          </div>
        </motion.div>
      </Layout>
    );
  }

  // If user is not authenticated, show landing page with footer
  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <SEO 
          title="SnapVote - Make Better Decisions Together"
          description="Create engaging polls, gather meaningful insights, and make better decisions together. Join the community of curious minds and decision makers."
        />
        <div className="min-h-screen flex flex-col">
          <div className="flex-grow">
            <Hero />
            <TopSnaps />
            <CashSnaps />
            <HowItWorks />
            <AIFeatures />
            <PrivacyProtection />
            <EmergingContent />
            <LaunchSection />
          </div>
          <Footer />
        </div>
      </motion.div>
    </AnimatePresence>
  );
}